<template>
  <div class="avatar-xs m-1" :class="[{ admin: isActive }, extraClasses]">
    <span
      class="avatar-title rounded-circle"
      v-bind:class="['named-', name[0]]"
    >{{ name | initials }}</span>
  </div>
</template>
<script>
export default {
    props:{
        name: {
            type: String,
            default: ""
        },
        admin: {
            type: String,
            default: "0"
        },
        extraClasses: {
            type: [String, Array, Object],
            default: ''
        }
    },
    computed: {
        isActive() {
            return this.admin === "1";
        }
    }
}
</script>